import { doc, getDoc } from "firebase/firestore";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import Upsell from "./Upsell";
import { db } from "../../../firebase";

const landingId = "CF_UPSELL";

const onLoad = async ({ session, landedAt, uid }) => {
  const prevAnswers = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;
  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  
  const userRef = doc(db, "users", uid);
  const docSnapshot = await getDoc(userRef);

  const { firstName } = docSnapshot.data();


  return {
    userId: uid,
    ...prevAnswers,
    landedAt,
    prevForm,
    currentLanding: landingId,
    userName: firstName
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(await nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <Upsell state={state} setState={setState} />
);

const nextPage = async (props) => `/formulario/cancelacion/lealtad?uid=${props.uid}`
const prevPage = (props) => `/formulario/cancelacion/razon?uid=${props.uid}`;

const fieldsStructure = [];

const upsellProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default upsellProps;
